import React from 'react';
import Calendar from './Calendar';

const ALLOWED_PANELS = ['decade', 'year', 'month'];

export default props => {
  return <Calendar {...props} allowedPanels={ALLOWED_PANELS} />;
};
